import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@prisjakt/ui-list-item';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';

const ExtraResources = props => {
  const { onClick, title, subtitle } = props;
  const { nodes } = props.resource;
  return (
    <Panel header={<PanelHeader title={title} subtitle={subtitle} />}>
      {nodes.filter(Boolean).map(item => (
        <ListItem
          key={item.pathName}
          name={item.name}
          link={item.pathName}
          image={
            item.logo && <img height="28" width="28" src={item.logo} alt="" />
          }
          showArrow
          onClick={onClick}
        />
      ))}
    </Panel>
  );
};

const { func, string, object } = PropTypes;

ExtraResources.propTypes = {
  title: string.isRequired,
  more: string.isRequired,
  name: string.isRequired,
  resource: object.isRequired,
  subtitle: string,
  onClick: func.isRequired,
  onShowAll: func.isRequired,
};

ExtraResources.defaultProps = {
  subtitle: undefined,
};

export default ExtraResources;
